import css_text from '/srv/www/htdocs/loc/app/styles/web_components/avatar.css';

export class YalwaAvatar extends HTMLElement {
    static get observedAttributes() {
        return ['appearance', 'size', 'status', 'border', 'src'];
    }

    constructor() {
        super();
        if (!this.shadowRoot) {
            this.attachShadow({mode: 'open'});
        }
        this.initialize_template();
		this.apply_css();
    }

    initialize_template() {
        if (!this.shadowRoot.firstChild) {
            this.shadowRoot.innerHTML = `
                <div class="avatar_container" part="container">
                    <div class="content" part="content">
                        <slot name="initials"></slot>
                        <img class="avatar_image" part="image" style="display:none;">
                        <slot name="placeholder"></slot>
                    </div>
                    <div class="status_badge" part="status"></div>
                </div>
            `;
        }
        this.container = this.shadowRoot.querySelector('.avatar_container');
        this.img = this.shadowRoot.querySelector('.avatar_image');
    }
	
	async apply_css() {
		await yalwa.basics.check_stylesheet_polyfill_needed();
		const sheet = new CSSStyleSheet();
		sheet.replaceSync(css_text + `
		.avatar_container:not([data-appearance="initials"]) slot[name="initials"] {
			display: none;
		}
		::slotted(span[slot="initials"]) {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;
			height: 100%;
			@include typography('label_md_semibold');
			border-radius: var(--radius_full);
			background-color: var(--color_background_brand_bold);
        	color: var(--color_text_inverse);
            box-sizing: border-box;
            transform: scale(98%);
		}`); // adding it here because this syntax breaks our ancient sass version
		this.shadowRoot.adoptedStyleSheets = [sheet];
		jQuery(this).removeClass('invisible');
	}

    connectedCallback() {
        this.render();
    }

    attributeChangedCallback() {
        this.render();
    }

    render() {
        const appearance = this.getAttribute('appearance') || 'placeholder';
        const size = this.getAttribute('size') || 'md';

        this.container.setAttribute('data-appearance', appearance);
        this.container.setAttribute('data-size', size);

        if (appearance === 'placeholder') {
            this.img.src = '/assets/0000_0000/images/yimage/62/1562.svg';
            this.img.style.display = 'block';
        } else if (appearance === 'image') {
			const src = this.getAttribute('src');
            this.img.src = src;
            this.img.style.display = 'block';
        } else {
            this.img.style.display = 'none';
        }
		const border = this.getAttribute('border');
		if (border) {
			this.container.setAttribute('data-border', border);
		} else {
			this.container.removeAttribute('data-border');
		}
    }
}

customElements.define('yalwa-avatar', YalwaAvatar);